import type { ReferenceOption } from '../../form/forms';

export const resolveOptionIdentity = (option: ReferenceOption) => {
    const optionWithExtendedRefs = option as ReferenceOption & {
        reference?: { id?: string };
        personReference?: { id?: string };
    };

    return (
        optionWithExtendedRefs?.id ||
        optionWithExtendedRefs?.ref?.id ||
        optionWithExtendedRefs?.reference?.id ||
        optionWithExtendedRefs?.personReference?.id
    );
};
